if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.addEventListeners()

 
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      addEventListeners() {
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500))
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false))
        })
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      filterImages(mediaId, prepend, colorSwatches, activeColor, enableColorFiltering = false) {
        if (!enableColorFiltering) return
        
        const santizeColorString = (colorString) => colorString?.replace(/\s+/g, '').replace(/-/g, '').toUpperCase()
        
        const verifyColorFromSrc = (colorFromSrc) => {
          return colorFromSrc && colorFromSrc
        }

        const existsInColorOptionValues = (colorToCheck, colorSwatches) => {
          const sanitizedColorToCheck = santizeColorString(colorToCheck)
          const sanitizedColorSwatches = colorSwatches.map(santizeColorString)
      
          return sanitizedColorSwatches.includes(sanitizedColorToCheck)
        }
      
        if (!colorSwatches?.length || !activeColor) return
      
        const imageContainers = Array.from(document.querySelectorAll('[data-image-thumbnail], [data-image-main-gallery]'))
        const sanitizedActiveColor = santizeColorString(activeColor)


        const imageColorValuesRaw = imageContainers.map((imageContainer) => {
          const altColor = imageContainer.dataset?.altColorValue ?? ''

          const srcColor = verifyColorFromSrc(imageContainer.dataset?.colorFromSrc) ?? ''

          const color = srcColor === '' ? altColor : srcColor

          if (color) {
            return {
              color,
              containerElement: imageContainer
            }
          }
          return null
        }).filter(Boolean)
      
        const colorAndThumbElements = imageColorValuesRaw.map(({ color, containerElement }) => {
          const hasMatchingColor = existsInColorOptionValues(color, colorSwatches)

          if (!hasMatchingColor) return null
      
          return [color, containerElement]
        }).filter(Boolean)


        colorAndThumbElements.forEach(([matchedColor, containerElement]) => {
      

          if (santizeColorString(matchedColor) === sanitizedActiveColor) {
            containerElement.classList.remove('hidden')
          } else {
            containerElement.classList.add('hidden')
          }
        })

      }

      setActiveMedia(mediaId, prepend, enableFilter = false) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);



        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

            if(enableFilter) {
              const onloadActiveThumbnail = this.elements.thumbnails.querySelector('[data-featured-image-thumbnail]')

              const sameThumbnail = activeThumbnail === onloadActiveThumbnail;
              if(sameThumbnail) {
                onloadActiveThumbnail.classList.remove('hidden')
              } else {
                onloadActiveThumbnail.classList.add('hidden')
              }
            }

            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
